<ng-container>
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header [mode]="mode" [importLabel]="modalTitle"></base-form-header>

    <mat-dialog-content fxLayout="column">
      <div *ngIf="customTemplate">
        <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
      </div>

      <form *ngIf="showExtraSelect && extraSelectConfig" [formGroup]="extraSelectConfig.formGroup">
        <base-form-input
          [items]="extraSelectConfig.items"
          [label]="extraSelectConfig.label"
          type="select"
          [controlName]="extraSelectConfig.controlName"
          [displayProperty]="extraSelectConfig.displayProperty || 'label'"
        ></base-form-input>
      </form>

      <base-form-input type="file" controlName="file" label="File"></base-form-input>

      <!-- Zone dédiée pour les messages d'erreurs d'import -->
      <div
        *ngIf="form.get('file')?.errors?.messages?.length"
        class="mt-4 mb-4 p-4 bg-red-50 rounded-lg border-l-4 border-red-500"
      >
        <div class="flex items-start gap-3 mb-3">
          <mat-icon class="text-red-600 flex-shrink-0">error_outline</mat-icon>
          <div class="flex-1">
            <h4 class="text-sm font-semibold text-red-800 mb-1">Erreurs d'importation détectées</h4>
            <p class="text-xs text-red-600">Veuillez corriger les erreurs suivantes avant de réimporter le fichier :</p>
          </div>
        </div>
        <div class="max-h-64 overflow-y-auto">
          <div
            *ngFor="let message of form.get('file')?.errors?.messages; let i = index"
            class="text-sm text-red-700 py-2 px-3 mb-1 bg-white rounded border border-red-200"
          >
            <span class="font-medium text-red-800">{{ i + 1 }}.</span>
            {{ message }}
          </div>
        </div>
      </div>

      <!-- Bouton Télécharger le modèle (style aligné avec les boutons d'instruction) -->
      <div *ngIf="downloadModel && canDownloadTemplateModel" class="mt-2">
        <button type="button" mat-stroked-button color="primary" (click)="exportTemplate()">
          <mat-icon class="mr-1">download</mat-icon>
          Télécharger le modèle
        </button>
      </div>

      <!-- Aide d'import disponible (brève), sous l'input et le bouton de téléchargement) -->
      <div
        *ngIf="(collectionName || genericId) && importInstructions.length > 0"
        class="mt-3 p-3 bg-primary-50 rounded"
      >
        <div class="flex items-center gap-2 mb-2">
          <!--                    <mat-icon class="text-primary-700">help_outline</mat-icon>-->
          <span class="text-sm text-primary-700 font-medium">Mode d'emploi</span>
        </div>
        <div class="flex flex-wrap gap-2">
          <button
            *ngFor="let instruction of importInstructions"
            type="button"
            mat-stroked-button
            color="primary"
            (click)="viewInstruction(instruction)"
            class="text-sm"
          >
            <mat-icon class="mr-1">description</mat-icon>
            {{ instruction.title }}
          </button>
        </div>
      </div>

      <div *ngIf="loadingInstructions" class="mt-2">
        <mat-spinner diameter="24"></mat-spinner>
        <span class="ml-2 text-sm text-gray-600">Chargement des modes d'emploi...</span>
      </div>

      <!-- Zone d'injection de contenu personnalisé -->
    </mat-dialog-content>

    <!-- Bouton déplacé au-dessus, conservé vide ici -->

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        [loading]="loading"
        [entityLabel]="entityLabel"
        (onImport)="import()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>
